if (!window.__comparisonSectionInitialized) {
  window.__comparisonSectionInitialized = true;

  const COLUMNS_SELECTOR = '.cs-columns';
  const ROW_SELECTOR = '[data-cs-row]';
  const SYNC_MIN_WIDTH = 750;
  const instances = new WeakMap();

  const debounce = (callback, wait = 120) => {
    let timer = null;

    return (...args) => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => callback(...args), wait);
    };
  };

  const clearRowHeights = (columns) => {
    columns.querySelectorAll(ROW_SELECTOR).forEach((row) => {
      row.style.removeProperty('min-height');
    });
  };

  const syncRowHeights = (columns) => {
    const left = columns.querySelector('.cs-column--left');
    const right = columns.querySelector('.cs-column--right');

    if (!left || !right) return;

    clearRowHeights(columns);

    if (window.innerWidth < SYNC_MIN_WIDTH) return;

    const leftRows = new Map();
    left.querySelectorAll(ROW_SELECTOR).forEach((row) => {
      leftRows.set(row.dataset.csRow, row);
    });

    const rightRows = new Map();
    right.querySelectorAll(ROW_SELECTOR).forEach((row) => {
      rightRows.set(row.dataset.csRow, row);
    });

    leftRows.forEach((leftRow, key) => {
      const rightRow = rightRows.get(key);
      if (!rightRow) return;

      const tallest = Math.max(leftRow.offsetHeight, rightRow.offsetHeight);
      leftRow.style.minHeight = `${tallest}px`;
      rightRow.style.minHeight = `${tallest}px`;
    });
  };

  const setup = (columns) => {
    if (!(columns instanceof HTMLElement) || instances.has(columns)) return;

    const onResize = debounce(() => syncRowHeights(columns));
    const observer = new ResizeObserver(onResize);
    observer.observe(columns);
    window.addEventListener('resize', onResize, { passive: true });

    const images = columns.querySelectorAll('.cs-column__image');
    images.forEach((image) => {
      if (!(image instanceof HTMLImageElement) || image.complete) return;
      image.addEventListener('load', onResize, { once: true });
      image.addEventListener('error', onResize, { once: true });
    });

    requestAnimationFrame(() => syncRowHeights(columns));
    instances.set(columns, { observer, onResize });
  };

  const teardown = (columns) => {
    const instance = instances.get(columns);
    if (!instance) return;

    instance.observer.disconnect();
    window.removeEventListener('resize', instance.onResize);
    instances.delete(columns);
  };

  const setupAll = (root = document) => {
    root.querySelectorAll(COLUMNS_SELECTOR).forEach((columns) => setup(columns));
  };

  const teardownAll = (root) => {
    root.querySelectorAll(COLUMNS_SELECTOR).forEach((columns) => teardown(columns));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setupAll());
  } else {
    setupAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;
    setupAll(target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;
    teardownAll(target);
  });
}
